import { brandedUuid } from '@multiplier/lib-shared-flavor';
export const BatchJobIdSchema = brandedUuid('Invalid batch job ID format');
export const BatchJobLineIdSchema = brandedUuid('Invalid batch job line ID format');
//# sourceMappingURL=BatchSchemas.js.map